import { PageHeaderContentProps } from './types';

export const PageHeader = ({ children }: PageHeaderContentProps) => (
    <div className="bg-white flex items-center rounded-b-lg pb-3 pt-2 sticky top-0 font-accent font-w-heading z-30">{children}</div>
);
